export default __webpack_public_path__ + "static/media/building.2862167d.svg";